export default __webpack_public_path__ + "static/IntroductiontoAITechnologyandAIAssistantCreation(Micro-credential)-4b9e5dbb0a713706b767bf8c295f9ae3.mp3";